import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./reminder.scss";
import { fetchVehicle } from "../../store/slices/Vehicle/thunk";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import { MdDelete } from "react-icons/md";

import EditIcon from "@mui/icons-material/Edit";
import { deleteReminder, fetchReminder } from "../../store/slices/thunk";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../../components/deleteModal";
import AddIcon from '@mui/icons-material/Add';
import { IoSearchOutline } from "react-icons/io5";
import Loader from "../../components/loader";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";
const ReminderList = () => {
  const [search, setSearch] = useState("");
  const dispatch: any = useDispatch();
  const [getAllReminder, setAllReminder] = useState([]);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const pageCount = Math.ceil(totalCount / 10);
  const { filteredData, filters, setFilter, clearFilter } = useClientFilter(getAllReminder);

  useEffect(() => {

    const getReminder = async () => {
      setIsLoading(true); // Start loader
      try {
        const response = await dispatch(fetchReminder(page, 10, search));
        if (response && response?.data?.data?.length > 0 && response?.isSuccess) {
          setAllReminder(response?.data?.data);
          setTotalCount(response?.data?.totalCount || 0);
        } else {
          setAllReminder([]);
          setTotalCount(response?.data?.totalCount || 0);
        }
      } catch (error) {
        console.log(getAllReminder);
        setAllReminder([]);
      } finally {
        setIsLoading(false); // Stop loader
      }
    };

    getReminder();
  }, [dispatch, page]);
  const gotoEdit = (id: string) => {
    navigate(`/edit-reminder/${id}`);
  };
  const handleDelete = async (id: string) => {
    const response = await dispatch(deleteReminder(id));
    if (response && response?.isSuccess) {
      const updatedReminder = getAllReminder.filter(
        (item: any) => item._id !== id
      );
      setAllReminder(updatedReminder);
    }
  };
  const handleDeleteClick = (id: string) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    if (deleteId) {
      await handleDelete(deleteId);
    }
    setOpenDialog(false);
    setDeleteId(null);
  };
  const navigateToAddreminder = () => {
    navigate("/add-reminder");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="reminder-list d-flex justify-content-between flex-row" style={{ flexShrink: 0 }}>
          <div className="d-flex flex-column">
            <h2 style={{ color: "#0f172a", fontWeight: "700", fontSize: "24px", margin: "0", fontFamily: "sans-serif" }}>
              Reminder System
            </h2>
            <p style={{ color: "#64748b", fontSize: "14px", margin: "4px 0 0 0", fontWeight: "400" }}>
              Set up maintenance and document reminders
            </p>
          </div>
        <p>
          {" "}
            <button className="px-2 py-2" onClick={navigateToAddreminder} style={{background:"#3b82f6", color:"#fff", borderRadius:"10px", height:"auto", width:"auto", border:"none"}}><AddIcon/>Add New Reminder</button>
        </p>
      </div>
      <Paper sx={{ padding: 2, marginTop: "20px", flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <div className="search-box align-items-baseline justify-content-start" style={{ flexShrink: 0 }}>
            <div className="search-wrapper">
              <IoSearchOutline className="search-icon" />
              <input
                placeholder="Search Reminders Here"
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>

          <TableContainer sx={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
          <Table className="table">
            <TableHead className="th">
   <TableRow className="table-h-row">
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    S.No
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    Vehicle
    <FilterPopover column="vehicle.vehicleName" filterType="text" currentValue={filters["vehicle.vehicleName"] || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    Date
    <FilterPopover column="date" filterType="text" currentValue={filters.date || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    Messege
    <FilterPopover column="message" filterType="text" currentValue={filters.message || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    Action
  </TableCell>
</TableRow>


            </TableHead>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Loader />
                </TableCell>
              </TableRow>
            ) : (

              <TableBody className="tb">
                {filteredData.map((item: any, index) => (
                  <TableRow key={index} className="t-row">
                    <TableCell className="table-cell">{index + 1}</TableCell>
                    <TableCell className="table-cell">
                      {item.vehicle.vehicleName || "--"}
                    </TableCell>
                    <TableCell className="table-cell">
                      {item.date
                        ? new Date(item.date).toLocaleDateString("en-GB")
                        : "--"}
                    </TableCell>
                   <TableCell className="table-cell">
                      {item.message || "--"}
                    </TableCell>
                    <TableCell className="table-cell">
                      <IconButton>
                        <MdDelete onClick={() => handleDeleteClick(item._id)} style={{ color: "red" }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}


                {filteredData.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Reminder Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}

          </Table>
        </TableContainer>
        </div>
        <nav style={{ flexShrink: 0 }}>
          <ul className="pagination justify-content-center">
            <li className={`page-item ${page === 1 && "disabled"}`}>
              <button className="page-link" onClick={() => setPage((p) => Math.max(p - 1, 1))}>Previous</button>
            </li>
            {Array.from({ length: Math.min(5, pageCount || 1) }, (_, i) => (
              <li key={i + 1} className={`page-item ${page === i + 1 && "active"}`}>
                <button className="page-link" onClick={() => setPage(i + 1)}>{i + 1}</button>
              </li>
            ))}
            {pageCount > 5 && (
              <>
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
                <li className="page-item">
                  <button className="page-link" onClick={() => setPage(pageCount)}>{pageCount}</button>
                </li>
              </>
            )}
            <li className={`page-item ${page === pageCount || pageCount === 0 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setPage((p) => Math.min(p + 1, pageCount || 1))}>Next</button>
            </li>
          </ul>
        </nav>
      </Paper>
      <ConfirmDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={confirmDelete}
      />
    </div>
  );
};

export default ReminderList;

